module.exports = __webpack_public_path__ + "img/kt-dfk.4b277740.png";